








































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";

@Component
export default class CustomFieldSelector extends Vue {
  @Prop({ default: () => ({}) }) value: any;
  @Prop() fields!: any;
  @Prop({ default: 12 }) cols!: number;
  @Prop({ default: 6 }) sm!: number;
  @Prop({ default: 4 }) md!: number;
  @Prop({ default: 3 }) lg!: number;
  @Prop({ default: 3 }) xl!: number;

  innerValue = JSON.parse(JSON.stringify(this.value));

  @Watch("value", { deep: true })
  onValueChange(newVal: any) {
    this.innerValue = newVal;
  }

  onInnerValueChange(newVal: any) {
    this.$emit("input", this.innerValue);
    this.$emit("change");
  }
}
